const LogoutIcon = (width = 24, height = 24, color = '#00675D') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24"><path d="M14 19v-.083A7.93 7.93 0 0 1 10 20c-4.411 0-8-3.589-8-8s3.589-8 8-8a7.93 7.93 0 0 1 4 1.083V2.838A9.954 9.954 0 0 0 10 2C4.478 2 0 6.477 0 12s4.478 10 10 10a9.954 9.954 0 0 0 4-.838V19zm4-9.592L20.963 12 18 14.592V13h-8v-2h8V9.408zM16 5v4H8v6h8v4l8-7-8-7z" fill="${color}"/></svg>
`;

export default LogoutIcon;
